import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output , ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DateOperationsComponent } from '../../../shared/date-operations/date-operations.component';
import { GmsconfirmComponent } from '../../dialogs/gmsconfirm/gmsconfirm.component';
import { UtilService } from '../../services/util/util.service';

@Component({
    selector: 'app-time-of-the-day',
    templateUrl: './time-of-the-day.component.html',
    styleUrls: ['./time-of-the-day.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TimeOfTheDayComponent implements OnInit {
  @Input() timeOfTheDayConfig: any;
  @Input() isModalPopup: boolean;
  @Input() additionalInfo: any;
  @Output() configuration = new EventEmitter();
  @Output() isModalClose = new EventEmitter();

  public timeOfTheDayForm: UntypedFormGroup;
  public minStartDate: any;
  public minEndDate: any;
  public timeVar: any;
  public timeStamps = [];
  public incorrectTimeStmp: boolean = false;
  public duplicateTime: boolean = false;
  public timeRangeError: boolean = false;
  public mnthlyDaySelect: boolean = true;
  public onSave: boolean = false;
  public selectedDays = [];
  public monthlyWeek = '';
  public monthlyWeekDay = '';
  public onDay = [
    { "value": 'Sun', "name": 'S', "isSelected": false },
    { "value": 'Mon', "name": 'M', "isSelected": false },
    { "value": 'Tue', "name": 'T', "isSelected": false },
    { "value": 'Wed', "name": 'W', "isSelected": false },
    { "value": 'Thu', "name": 'T', "isSelected": false },
    { "value": 'Fri', "name": 'F', "isSelected": false },
    { "value": 'Sat', "name": 'S', "isSelected": false }
  ];
  public onTheWeek = [
    { value: '1', name: 'First' },
    { value: '2', name: 'Second' },
    { value: '3', name: 'Third' },
    { value: '4', name: 'Fourth' },
    { value: '5', name: 'Fifth' }
  ];
  public onWeekDay = [
    { value: 'SUN', name: 'Sunday' },
    { value: 'MON', name: 'Monday' },
    { value: 'TUE', name: 'Tuesday' },
    { value: 'WED', name: 'Wednesday' },
    { value: 'THU', name: 'Thursday' },
    { value: 'FRI', name: 'Friday' },
    { value: 'SAT', name: 'Saturday' }
  ];
  public callpage;
  public mode;
  constructor(private fb: UntypedFormBuilder, private dateOps: DateOperationsComponent,
    private _decimalPipe: DecimalPipe, private utilService: UtilService, private modalRef: NgbModal,) { }

  ngOnInit(): void {
    this.callpage = this.timeOfTheDayConfig?.callPage;
    this.mode = this.timeOfTheDayConfig?.mode;
    this.initializeFormData();
    this.initializeTimeValues();
    if (this.timeOfTheDayConfig && typeof this.timeOfTheDayConfig == 'object' && Object.keys(this.timeOfTheDayConfig).length != 0) {
      this.setConfiguration(this.timeOfTheDayConfig);
    }
  }

  initializeFormData() {
    let dateOps = this.dateOps.getAllDatePropValues(new Date());
    this.minStartDate = dateOps.minDate;
    this.minEndDate = dateOps.minDate;
    let today = this.minEndDate.month + '-' + this.minEndDate.day + '-' + this.minEndDate.year;
    let tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.minEndDate = { year: tomorrow.getFullYear(), month: tomorrow.getMonth() + 1, day: tomorrow.getDate() };//tomorrow;
    this.timeOfTheDayForm = this.fb.group({
      gamePlayDay: [{ year: dateOps.yearNow, month: dateOps.monthNow, day: dateOps.dayNow }, Validators.required],
      daysOfWeekOp: ['', Validators.required],
      repEvrWeek: ['', Validators.required],
      repEvrMonth: ['', Validators.required],
      daysSelect: ['', Validators.required],
      onDayOp: ['onDay', Validators.required],
      onDay: ['', Validators.required],
      onTheWeek: ['', Validators.required],
      onWeekDay: ['', Validators.required],
      endDate: [{ year: tomorrow.getFullYear(), month: tomorrow.getMonth() + 1, day: tomorrow.getDate() }, Validators.required]
    });
    this.timeOfTheDayForm.controls.onTheWeek.disable();
    this.timeOfTheDayForm.controls.onWeekDay.disable();
  }

  initializeTimeValues() {
    this.timeVar = {
      timeStmpFrmhh: '',
      timeStmpFrmmm: '',
      timeStmpFrmss: '',
      timeStmpTohh: '',
      timeStmpTomm: '',
      timeStmpToss: ''
    }
  }

  gamePlayDay(event, id) {
    let selectedDate = event.year + '-' + event.month + '-' + event.day;
    let newDate = new Date(selectedDate);
    if ((event.year && event.month && event.day && id == 'startDate') || (event.year && event.month && event.day && id == 'endDate')) {
      if (id == 'startDate') {
        newDate.setDate(newDate.getDate() + 1);
        this.timeOfTheDayForm.controls.endDate.setValue({
          year: newDate.getFullYear(),
          month: newDate.getMonth() + 1,
          day: newDate.getDate()
        });
        this.minEndDate = { year: newDate.getFullYear(), month: newDate.getMonth() + 1, day: newDate.getDate() };
      }
    }
  }
  checkDigits(event) {
    let val = event.target.value;
    let eleId = event.target.id;
    console.log("eventttt" + val, val.length)
    if (val && val.length > 2) {
      this.timeVar[eleId] = "";
      this.utilService.snackMsg("Allowed ony 2 digits.");
    }
  }

  hh(event) {
    let hr = event.target.value;
    let eleId = event.target.id;
    if (hr < 0 || hr >= 24)
      hr = 0;
    let hour = this._decimalPipe.transform(hr, "2.0-0");
    this.timeVar[eleId] = hour;
  }

  mm(event) {
    let min = event.target.value;
    let eleId = event.target.id;
    if (min < 0 || min >= 60)
      min = 0;
    let minute = this._decimalPipe.transform(min, "2.0-0");
    this.timeVar[eleId] = minute;
  }

  ss(event) {
    let sec = event.target.value;
    let eleId = event.target.id;
    if (sec < 0 || sec >= 60)
      sec = 0;
    let second = this._decimalPipe.transform(sec, "2.0-0");
    this.timeVar[eleId] = second;
  }

  addTime() {
    this.duplicateTime = false;
    this.incorrectTimeStmp = false;
    this.timeRangeError = false;
    if (this.timeVar.timeStmpFrmhh != '' && this.timeVar.timeStmpFrmmm != '' && this.timeVar.timeStmpFrmss != '' &&
      this.timeVar.timeStmpTohh != '' && this.timeVar.timeStmpTomm != '' && this.timeVar.timeStmpToss != '' &&
      this.timeVar.timeStmpFrmhh != null && this.timeVar.timeStmpFrmmm != null && this.timeVar.timeStmpFrmss != null &&
      this.timeVar.timeStmpTohh != null && this.timeVar.timeStmpTomm != null && this.timeVar.timeStmpToss != null) {
      if ((parseInt(this.timeVar.timeStmpFrmhh) * 60 * 60 + parseInt(this.timeVar.timeStmpFrmmm) * 60 + parseInt(this.timeVar.timeStmpFrmss)) >=
        (parseInt(this.timeVar.timeStmpTohh) * 60 * 60 + parseInt(this.timeVar.timeStmpTomm) * 60 + parseInt(this.timeVar.timeStmpToss))) {
        this.incorrectTimeStmp = true;
        return;
      }

      let fromTimestamp: any = new Date(0, 0, 0, this.timeVar.timeStmpFrmhh, this.timeVar.timeStmpFrmmm, this.timeVar.timeStmpFrmss);
      let toTimestamp: any = new Date(0, 0, 0, this.timeVar.timeStmpTohh, this.timeVar.timeStmpTomm, this.timeVar.timeStmpToss);
      let promoTime = (toTimestamp - fromTimestamp) / 1000;
      if (promoTime && this.additionalInfo?.feature_play_avail_time && (promoTime <= this.additionalInfo?.feature_play_avail_time)) {
        this.utilService.snackMsg("Promo time should be greater than Feature Play Availability Time");
        return;
      }

      let newTime = {
        "from": `${this.timeVar.timeStmpFrmhh}:${this.timeVar.timeStmpFrmmm}:${this.timeVar.timeStmpFrmss}`,
        "to": `${this.timeVar.timeStmpTohh}:${this.timeVar.timeStmpTomm}:${this.timeVar.timeStmpToss}`
      }
      if (this.timeStamps.length > 0) {
        for (let item of this.timeStamps) {
          if (item.from == newTime.from || item.to == newTime.to || item.from == newTime.to || item.to == newTime.from) {
            this.duplicateTime = true;
            return;
          }
        }
      }
      let newFrmTime = (parseInt(newTime.from.split(':')[0]) * 60 * 60 + parseInt(newTime.from.split(':')[1]) * 60 + parseInt(newTime.from.split(':')[2]));
      let newToTime = (parseInt(newTime.to.split(':')[0]) * 60 * 60 + parseInt(newTime.to.split(':')[1]) * 60 + parseInt(newTime.to.split(':')[2]));
      if (this.timeStamps.length > 0) {
        for (let item of this.timeStamps) {
          let eachFrmTime = (parseInt(item.from.split(':')[0]) * 60 * 60 + parseInt(item.from.split(':')[1]) * 60 + parseInt(item.from.split(':')[2]));
          let eachToTime = (parseInt(item.to.split(':')[0]) * 60 * 60 + parseInt(item.to.split(':')[1]) * 60 + parseInt(item.to.split(':')[2]));
          for (let i = newFrmTime; i <= newToTime; i++) {
            if (i >= eachFrmTime && i <= eachToTime) {
              this.timeRangeError = true;
              return;
            }
          }
        }
      }
      this.timeStamps.push(newTime);
      this.initializeTimeValues();
    } else {
      this.utilService.snackMsg("Invalid Time Stamp");
    }
  }

  removeTimeStmp(ind) {
    this.timeStamps.splice(ind, 1);
  }

  onChangeDaysofWeek(e) {
    if (e.target.value == 'weekly') {
      this.timeOfTheDayForm.controls.repEvrMonth.setValue('');
      this.timeOfTheDayForm.controls.onTheWeek.setValue('');
      this.timeOfTheDayForm.controls.onWeekDay.setValue('');
      this.timeOfTheDayForm.controls.onDayOp.setValue('onDay');
      this.timeOfTheDayForm.controls.onDay.setValue('');
    } else {
      this.timeOfTheDayForm.controls.repEvrWeek.setValue('');
      this.selectedDays = [];
      this.onDay.forEach(x => x.isSelected = false);
    }
  }

  setRadio(e) {
    let selectedOp = e.target.value;
    if (selectedOp == 'onDay') {
      this.mnthlyDaySelect = true;
      this.timeOfTheDayForm.controls.onTheWeek.setValue('');
      this.timeOfTheDayForm.controls.onWeekDay.setValue('');
      this.timeOfTheDayForm.controls.onTheWeek.disable();
      this.timeOfTheDayForm.controls.onWeekDay.disable();
      this.timeOfTheDayForm.controls.onDay.enable();
    } else {
      this.mnthlyDaySelect = false;
      this.timeOfTheDayForm.controls.onTheWeek.enable();
      this.timeOfTheDayForm.controls.onWeekDay.enable();
      this.timeOfTheDayForm.controls.onDay.setValue('');
      this.timeOfTheDayForm.controls.onDay.disable();
    }
  }

  // repeatEvry(e) {
  //   if (e.target.id == 'repEvrWeek') {
  //     if (e.target.value > 53) {
  //       this.timeOfTheDayForm.controls.repEvrWeek.setValue('');
  //     }
  //   }
  //   if (e.target.id == 'repEvrMonth') {
  //     if (e.target.value > 12) {
  //       this.timeOfTheDayForm.controls.repEvrMonth.setValue('');
  //     }
  //   }
  // }

  onMonthlyWeek(e) {
    if (e.target.id == 'onTheWeek') {
      let idx = this.onTheWeek.findIndex((x => x.value == e.target.value));
      this.monthlyWeek = this.onTheWeek[idx].name;
    } else {
      let idx = this.onWeekDay.findIndex((x => x.value == e.target.value));
      this.monthlyWeekDay = this.onWeekDay[idx].name;
    }
  }

  setConfiguration(config) {
    if (config?.[config?.start_date_field] == "") {
      this.timeOfTheDayForm.controls.gamePlayDay.setValue({ year: null, month: null, day: null });
    } else {
      let startDate = config?.[config.start_date_field]?.split("/");
      if (startDate != undefined) {
        this.timeOfTheDayForm.controls?.gamePlayDay?.setValue({ year: parseInt(startDate[2]), month: parseInt(startDate[1]), day: parseInt(startDate[0]) });
      }
    }
    if (config.timestamp) {
      config.timestamp.forEach(x => {
        this.timeStamps.push({ "from": x[0], "to": x[1] });
      })
    }
    if (config.weekly || config.monthly) {
      let endDate = config?.[config?.end_date_field]?.split("/");
      this.selectedDays = [];
      if (config.weekly) {
        this.timeOfTheDayForm.controls.daysOfWeekOp.setValue('weekly');
        this.timeOfTheDayForm.controls.repEvrWeek.setValue(config.weekly.repeat);
        config.weekly.day.forEach(x => {
          this.onDay.forEach(y => {
            if (x == y.value) {
              y.isSelected = true;
              this.selectedDays.push(y.value);
            }
          });
        });
        this.timeOfTheDayForm.controls.endDate.setValue({ year: parseInt(endDate[2]), month: parseInt(endDate[1]), day: parseInt(endDate[0]) });
      } else {
        this.timeOfTheDayForm.controls.daysOfWeekOp.setValue('monthly');
        this.timeOfTheDayForm.controls.repEvrMonth.setValue(config.monthly.repeat);
        this.timeOfTheDayForm.controls.endDate.setValue({ year: parseInt(endDate[2]), month: parseInt(endDate[1]), day: parseInt(endDate[0]) });
        if (config.monthly.days || config.monthly.weeks) {
          if (config.monthly.days) {
            this.timeOfTheDayForm.controls.onDayOp.setValue('onDay');
            this.timeOfTheDayForm.controls.onDay.setValue(config.monthly.days);
          } else {
            this.timeOfTheDayForm.controls.onDayOp.setValue('onWeek');
            this.timeOfTheDayForm.controls.onTheWeek.setValue(config.monthly.weeks.slice(0, 1));
            this.timeOfTheDayForm.controls.onWeekDay.setValue(config.monthly.weeks.slice(1, 4));
            this.timeOfTheDayForm.controls.onTheWeek.enable();
            this.timeOfTheDayForm.controls.onWeekDay.enable();
            this.timeOfTheDayForm.controls.onDay.disable();
            let idx1 = Number(this.timeOfTheDayForm.controls.onTheWeek.value) - 1;
            let idx2 = this.onWeekDay.findIndex(x => x.value == this.timeOfTheDayForm.controls.onWeekDay.value);
            this.monthlyWeek = this.onTheWeek[idx1].name;
            this.monthlyWeekDay = this.onWeekDay[idx2].name;
          }
        }
      }
    }
  }

  saveConfig() {
    this.onSave = true;
    let formData = this.timeOfTheDayForm.value;
    let { gamePlayDay, onDayOp, onDay, daysOfWeekOp, repEvrWeek, repEvrMonth, onTheWeek, onWeekDay, endDate } = formData;
    if (!(gamePlayDay.year && gamePlayDay.month && gamePlayDay.day)) {
      this.utilService.snackMsg("Please Enter Start Date");
      return;
    }
    this.selectedDays = [];
    this.onDay.forEach((day) => {
      if (day.isSelected) this.selectedDays.push(day.value);
    });
    if ((this.timeStamps.length == 0) ||
      (daysOfWeekOp == 'weekly' && (repEvrWeek == '' || repEvrWeek == null || repEvrWeek == 'null' || this.selectedDays.length == 0 || endDate == '')) ||
      (daysOfWeekOp == 'monthly' && (repEvrMonth == '' || repEvrMonth == null || repEvrMonth == 'null' ||
        (onDayOp == 'onDay' && (onDay == '' || onDay == null || onDay == 'null' || endDate == '')) ||
        (onDayOp == 'onWeek' && (onTheWeek == '' || onTheWeek == null || onTheWeek == 'null' ||
          onWeekDay == '' || onWeekDay == null || onWeekDay == 'null' || endDate == ''))))) {
      this.utilService.snackMsg("Please enter all the required fields in time configuration");
      return;
    }

    let timeOfTheDayData = {};
    timeOfTheDayData[this.timeOfTheDayConfig?.start_date_field] = (this._decimalPipe.transform(gamePlayDay.day, '2.0-0') + '/' + this._decimalPipe.transform(gamePlayDay.month, '2.0-0') + '/' + gamePlayDay.year);

    let timestmp = { "timestamp": [] };
    for (let item of this.timeStamps) {
      timestmp['timestamp'].push([item.from, item.to]);
    }
    Object.assign(timeOfTheDayData, timestmp);
    if (daysOfWeekOp == 'weekly') {
      let wkly = {
        "weekly": {
          "repeat": repEvrWeek,
          "day": this.selectedDays
        },
      };
      wkly[this.timeOfTheDayConfig?.end_date_field] = (this._decimalPipe.transform(endDate.day, '2.0-0') + '/' + this._decimalPipe.transform(endDate.month, '2.0-0') + '/' + endDate.year);
      Object.assign(timeOfTheDayData, wkly);

    } else if (daysOfWeekOp == 'monthly') {
      let mnthly = {
        "monthly": { "repeat": repEvrMonth },
      }
      mnthly[this.timeOfTheDayConfig?.end_date_field] = (this._decimalPipe.transform(endDate.day, '2.0-0') + '/' + this._decimalPipe.transform(endDate.month, '2.0-0') + '/' + endDate.year);
      if (onDayOp == 'onDay') {
        let day = { "days": onDay }
        Object.assign(mnthly.monthly, day);
      } else {
        let week = { "weeks": (onTheWeek + onWeekDay) }
        Object.assign(mnthly.monthly, week);
      }
      Object.assign(timeOfTheDayData, mnthly);
    } else {
      let endDate = {};
      endDate[this.timeOfTheDayConfig?.end_date_field] = (this._decimalPipe.transform(gamePlayDay.day, '2.0-0') + '/' + this._decimalPipe.transform(gamePlayDay.month, '2.0-0') + '/' + gamePlayDay.year);
      Object.assign(timeOfTheDayData, endDate);
    }

    let ngbModalOptions: NgbModalOptions = {
      "backdrop": 'static',
      "keyboard": false,
      "centered": true
    };
    const modalRef = this.modalRef.open(GmsconfirmComponent, ngbModalOptions);
    modalRef.componentInstance.configObj = {
      "title": 'Confirmation',
      "message": 'Are you sure you want to save all your changes ?',
      "btnOkText": 'Ok',
      "btnCancelText": 'Cancel'
    };
    modalRef.componentInstance.confirmed.subscribe((result) => {
      if (result && result == true) {
        this.onSave = false;
        this.isModalClose.emit(result);
        this.configuration.emit(timeOfTheDayData);
        this.timeOfTheDayForm.reset();
        this.timeStamps = [];
        this.onDay.forEach(x => x.isSelected = false);
      } else {
        console.log("Cancel and dismiss");
      }
    });
  }

  closeModal() {
    this.isModalClose.emit(true);
  }
}
